import { styled } from '@mui/material';

export const StyledContainer = styled('div')``;
